module.exports = __webpack_public_path__ + "img/win_line.c40eefd1.png";